"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.error = error;
function error(isError, component, message) {
  if (!!isError && console !== undefined) {
    console.error("[Error][zen-design ".concat(component, "]: ").concat(message));
  }
}